{
  "version": 1,
  "asset_id": "bdfa28c7-1baf-4ac5-8877-ca847e54569d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/bdfa28c7-1baf-4ac5-8877-ca847e54569d/umair-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/bdfa28c7-1baf-4ac5-8877-ca847e54569d/umair-640.webp",
  "original_filename": "umair-640.webp",
  "size": 16694,
  "content_type": "image/webp",
  "created_at": "2026-08-02T02:38:44Z"
}
